import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import {
  environment,
  transactionIdInterceptor,
} from '@esp-enrollment-form/shared-utils';

import { provideCompass } from '@pwc/compass';

import { APP_SELECTOR } from './app.config-constants';
import { appRoutes } from './app.routes';
import { errorInterceptor } from './interceptors/error.interceptor';
import { loadingInterceptor } from './interceptors/loading.interceptor';
import { authInterceptor } from './interceptors/token.interceptor';
import { provideBaseHref } from './providers/app-base-href.provider';
import { provideOrigin } from './providers/app-origin.provider';
import { provideLocationStrategy } from './providers/location-strategy.provider';
import { provideESPShadowDomOverlay } from './providers/shadow-dom-overlay.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideZonelessChangeDetection(),
    provideHttpClient(
      withInterceptors([
        loadingInterceptor,
        errorInterceptor,
        authInterceptor,
        transactionIdInterceptor,
      ]),
    ),
    provideNativeDateAdapter(),
    provideBaseHref(),
    provideOrigin(),
    provideLocationStrategy(),
    provideCompass({
      icons: {
        compass: {
          basePath: `${environment.assetsUrl}/assets/icons`,
        },
        app: {
          basePath: `${environment.assetsUrl}/assets/icons`,
          prefix: 'esp',
        },
      },
    }),
    provideESPShadowDomOverlay({ selector: APP_SELECTOR }),
  ],
};
